import { ActionBarPrimitive, AssistantIf } from '@assistant-ui/react';
import { IconCheck, IconCopy, IconDownload, IconRefresh } from '@tabler/icons-react';

import { TooltipIconButton } from '../tooltip-icon-button/TooltipIconButton.tsx';
import classes from './AssistantActionBar.module.css';

/** Action bar for assistant messages with copy, export, and regeneration controls. */
export function AssistantActionBar() {
  return (
    <ActionBarPrimitive.Root
      autohide="not-last"
      autohideFloat="single-branch"
      className={classes.assistantActionBar}
      hideWhenRunning
    >
      <ActionBarPrimitive.Copy asChild>
        <TooltipIconButton tooltip="Copy">
          {/* Show checkmark briefly after successful copy */}
          <AssistantIf condition={({ message }) => message.isCopied}>
            <IconCheck />
          </AssistantIf>
          <AssistantIf condition={({ message }) => !message.isCopied}>
            <IconCopy />
          </AssistantIf>
        </TooltipIconButton>
      </ActionBarPrimitive.Copy>
      <ActionBarPrimitive.ExportMarkdown asChild>
        <TooltipIconButton tooltip="Export as Markdown">
          <IconDownload />
        </TooltipIconButton>
      </ActionBarPrimitive.ExportMarkdown>
      <ActionBarPrimitive.Reload asChild>
        <TooltipIconButton tooltip="Refresh">
          <IconRefresh />
        </TooltipIconButton>
      </ActionBarPrimitive.Reload>
    </ActionBarPrimitive.Root>
  );
}
